module.exports = __webpack_public_path__ + "img/sword-air-03.73d34fe0.png";